import { Store } from 'src/store/index';

const getFrameUpsellFramePreview = (store: Store) => store.upsell.frameUpsellPopupData?.items[store.upsell.frameUpsellSelectedFrame || 0]?.previewUrl;
export default getFrameUpsellFramePreview;
